import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'localDateTime',
})

export class LocalDateTimePipe implements PipeTransform {
  transform(date: Date = null): string {
    if (date) {
      let localDate = new Date(date); // val is in UTC
      let localOffset = localDate.getTimezoneOffset() * 60000;
      let localTime = localDate.getTime() - localOffset;

      localDate.setTime(localTime);
      return formatDate(localDate, 'MM/dd/yyyy h:mm a', 'en-US');
    }
    else {
      return null;
    }
  }
}

@Pipe({
  name: 'localDate',
})

export class LocalDatePipe implements PipeTransform {
  transform(date: Date = null): string {
    return date ? formatDate(new Date(date), 'MM/dd/yyyy', 'en-US') : '-';
  }
}

@Pipe({
  name: 'localDateTimeSecond',
})

export class LocalDateTimeSecondPipe implements PipeTransform {
  transform(date: Date = null): string {
    if (date) {
      let localDate = new Date(date); // val is in UTC
      let localOffset = localDate.getTimezoneOffset() * 60000;
      let localTime = localDate.getTime() - localOffset;

      localDate.setTime(localTime);
      return formatDate(localDate, 'MM/dd/yyyy h:mm:ss a', 'en-US');
    }
    else {
      return null;
    }
  }
}

@Pipe({
  name: 'localTimeSecond',
})

export class LocalTimeSecondPipe implements PipeTransform {
  transform(date: Date = null): string {
    if (date) {
      let localDate = new Date(date); // val is in UTC
      let localOffset = localDate.getTimezoneOffset() * 60000;
      let localTime = localDate.getTime() - localOffset;

      localDate.setTime(localTime);
      return formatDate(localDate, 'h:mm:ss', 'en-US');
    }
    else {
      return null;
    }
  }
}

@Pipe({
  name: 'localTime',
})

export class LocalTimePipe implements PipeTransform {
  transform(date: Date = null): string {
    if (date) {
      let localDate = new Date(date); // val is in UTC
      let localOffset = localDate.getTimezoneOffset() * 60000;
      let localTime = localDate.getTime() - localOffset;

      localDate.setTime(localTime);
      return formatDate(localDate, 'h:mm a', 'en-US');
    }
    else {
      return null;
    }
  }
}


@Pipe({
  name: "phonepipe"
})
export class PhonePipe {
  transform(value: string): string {
    if (!value) {
      return value;
    }

    const cleanedValue = value.replace(/\D/g, ''); // Remove non-digit characters
    // Handle cases where the number might not be 10 digits
    if (cleanedValue.length !== 10) {
      return ''; // Invalid phone number
    }

    // Apply the US phone number format
    return cleanedValue.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
}

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {
  private units = ['bytes', 'KB', 'MB', 'GB', 'TB'];

  transform(bytes: number | null | undefined): string {
    if (bytes === null || bytes === undefined || bytes === 0) return '0 bytes';

    const k = 1024;
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + this.units[i];
  }
}

@Pipe({
  name: 'decimalPipe',
})
export class DecimalPipe {
  transform(value: number, format: string): string | null {
    // Implementation for decimal formatting
     return this.transform(value, '1.2-2');
  }
}


@Pipe({
  name: 'emailSplit',
})
export class EmailSplitPipe {

  transform(value: string, part: 'username' | 'domain' = 'username'): string {
    if (!value || !value.includes('@')) {
      return value;
    }

    const [username, domain] = value.split('@');

    return part === 'username' ? username : domain;
  }
}